module.exports = "/images/cover-sidebar.jpg?e2b23e5414eff4f98325f5366f32377b";